module.exports = __webpack_public_path__ + "img/waterpolo-4.b42d0518.png";